import React from 'react';
import styled from 'styled-components';
import ReactDOM from 'react-dom';
export function triggerRootClick() {
    // HACK: to close the popup from outside
    // trigger a document click to close the popup.
    // This is needed because which ever component needs to
    // close popover, doesn't have access to popover's
    // handleClick to properly remove the global event handler.
    // document.removeEventListener( 'click', this.handleClick, false );
    // doing the click on root, will force popover to close itself
    // and remove it's global handler.
    const rootDOM = document.getElementById('root');
    if (rootDOM) {
        rootDOM.click();
    }
}
export default class Popover extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.updateChildrenVisibility = (childrenVisible) => {
            this.setState(prevState => ({
                ...prevState,
                childrenVisible: childrenVisible
            }));
            this.props.onToggleMenu && this.props.onToggleMenu(childrenVisible);
        };
        this.hideChildren = () => {
            this.updateChildrenVisibility(false);
            document.removeEventListener('click', this.handleClick, false);
        };
        this.delayedHideChildren = () => {
            const hideChildrenRef = window.setTimeout(this.hideChildren, 50);
            this.setState({ hideChildrenRef });
        };
        this.showChildren = () => {
            if (this.props.shouldPopoverOpen()) {
                document.body.addEventListener('click', this.handleClick, false);
                this.updateChildrenVisibility(true);
            }
        };
        this.handleClick = event => {
            const foundSelf = ReactDOM.findDOMNode(this);
            if (this.props.hideOnMouseOutClick && (!foundSelf || (document.contains(event.target) && !foundSelf.contains(event.target)))) {
                this.hideChildren();
            }
        };
        this.handleChildrenClicked = event => {
            event.stopPropagation();
            if (this.props.hideOnChildrenClicked) {
                this.delayedHideChildren();
            }
        };
        this.handleMouseOver = () => {
            if (!this.props.autoHideOnMouseOut) {
                return;
            }
            if (this.state.timerRef) {
                clearTimeout(this.state.timerRef);
            }
        };
        this.toggleMenu = event => {
            event.stopPropagation();
            if (this.state.childrenVisible) {
                this.hideChildren();
            }
            else {
                this.showChildren();
            }
        };
        this.handleMouseOut = () => {
            if (!this.props.autoHideOnMouseOut) {
                return;
            }
            if (!this.state.childrenVisible) {
                return;
            }
            const timerRef = window.setTimeout(this.hideChildren, 3000);
            this.setState(prevState => ({
                ...prevState,
                timerRef: timerRef
            }));
        };
        this.state = {
            childrenVisible: props.isOpen || false,
            prevIsOpen: props.isOpen,
            timerRef: 0,
            hideChildrenRef: 0
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.isOpen !== state.prevIsOpen) {
            return {
                childrenVisible: props.isOpen,
                prevIsOpen: props.isOpen,
            };
        }
        return null;
    }
    componentWillUnmount() {
        document.body.removeEventListener('click', this.handleClick, false);
        window.clearTimeout(this.state.timerRef);
        window.clearTimeout(this.state.hideChildrenRef);
    }
    render() {
        const { shadowCss, className, HeaderComponent, ChildrenComponent, PopoverWrapper = DefaultPopoverWrapper, HeaderWrapper = DefaultHeaderWrapper, ChildrenWrapper = DefaultChildrenWrapper, } = this.props;
        return React.createElement(PopoverWrapper, { onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut, className: className },
            React.createElement(HeaderWrapper, { onClick: this.toggleMenu, isOpen: this.state.childrenVisible }, HeaderComponent),
            React.createElement(ChildrenWrapper, { isOpen: this.state.childrenVisible, shadowCss: shadowCss, onClick: this.handleChildrenClicked }, this.state.childrenVisible &&
                ChildrenComponent));
    }
}
Popover.defaultProps = {
    hideOnMouseOutClick: true,
    shouldPopoverOpen: () => (true),
};
const DefaultPopoverWrapper = styled.div `
`;
const DefaultHeaderWrapper = styled.div `

`;
export const DefaultChildrenWrapper = styled("div") `
  position: absolute;

  display: none;
  display: ${props => props.isOpen && 'inline-block'};
  outline: none;
  
  background-color: ${props => props.theme.colors.white};
  border-radius: 3px;
  
  box-shadow: ${props => props.shadowCss || props.theme.boxShadows.soft};
  
  z-index: 900;
`;
//# sourceMappingURL=Popover.js.map